import "@babel/polyfill";


import Vue from "vue";
import "@/prototype";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css/normalize.css";
import "./styles/global.styl";
import {ValidationProvider, ValidationObserver} from "@/Validator";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VideoPlayer from 'vue-video-player'
import BigPowerTable from "big-power-table"
import Print from './utils/print';
import 'ant-design-vue/dist/antd.css';
Vue.use(Print);
import Vant from 'vant';
import 'vant/lib/index.css';
import Antd from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import Sentry from './sentry' // 引入Sentry配置
const hostWithPort = window.location.host;

function safeStringify(value) {
  try {
    return JSON.stringify(value)
  } catch (e) {
    return String(value)
  }
}

function readStorage(storage) {
  const result = {};

  try {
    if (!storage) return result;

    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key == null) continue;

      try {
        result[key] = storage.getItem(key);
      } catch (e) {
        result[key] = `[读取失败: ${e && e.message ? e.message : e}]`;
      }
    }
  } catch (e) {
    result.__readError = e && e.message ? e.message : String(e);
  }

  return result;
}

function readBrowserStorage(storageName) {
  try {
    return readStorage(window[storageName]);
  } catch (e) {
    return {
      __readError: e && e.message ? e.message : String(e)
    }
  }
}

function readCookie() {
  const cookieRaw = (() => {
    try {
      return document.cookie || '';
    } catch (e) {
      return `[读取失败: ${e && e.message ? e.message : e}]`;
    }
  })();

  const cookie = {};
  if (!cookieRaw || cookieRaw.indexOf('读取失败') > -1) {
    return { cookie, cookieRaw };
  }

  cookieRaw.split(';').forEach(item => {
    const pair = item.trim();
    if (!pair) return;

    const eqIndex = pair.indexOf('=');
    const rawKey = eqIndex > -1 ? pair.slice(0, eqIndex) : pair;
    const rawValue = eqIndex > -1 ? pair.slice(eqIndex + 1) : '';

    try {
      cookie[decodeURIComponent(rawKey)] = decodeURIComponent(rawValue);
    } catch (e) {
      cookie[rawKey] = rawValue;
    }
  });

  return { cookie, cookieRaw };
}

function serializeError(errorLike) {
  if (errorLike instanceof Error) {
    return {
      name: errorLike.name,
      message: errorLike.message,
      stack: errorLike.stack
    }
  }

  if (errorLike && typeof errorLike === 'object') {
    return {
      name: errorLike.name,
      message: errorLike.message || safeStringify(errorLike),
      stack: errorLike.stack,
      raw: safeStringify(errorLike)
    }
  }

  return {
    name: typeof errorLike,
    message: errorLike == null ? String(errorLike) : String(errorLike)
  }
}

function getFrontendErrorMessage(type, errorLike) {
  const errorInfo = serializeError(errorLike);
  return `前端错误: ${window.location.href} ${type} - ${errorInfo.message || '未知错误'}`
}

function getStorageContext() {
  const cookieInfo = readCookie();

  return {
    localStorage: readBrowserStorage('localStorage'),
    sessionStorage: readBrowserStorage('sessionStorage'),
    cookie: cookieInfo.cookie,
    cookieRaw: cookieInfo.cookieRaw
  }
}

function shouldCaptureFrontendException() {
  return hostWithPort.includes('oem') ||
    hostWithPort.includes('localhost') ||
    hostWithPort.includes('127.0.0.1')
}

function captureFrontendException(type, errorLike, extra = {}) {
  if (!shouldCaptureFrontendException()) return;

  const errorInfo = serializeError(errorLike);
  const errorMessage = getFrontendErrorMessage(type, errorLike);
  const error = new Error(errorMessage);
  error.name = 'FrontendError';
  if (errorInfo.stack) {
    error.stack = errorInfo.stack;
  }

  Sentry.captureException(error, {
    message: errorMessage,
    level: 'error',
    tags: {
      priority: 'high',
      error_type: 'frontend'
    },
    extra: {
      error: errorInfo,
      storage: getStorageContext(),
      url: window.location.href,
      ...extra
    }
  })
}



// import VConsole from 'vconsole';
// const vConsole = new VConsole();

// 设置Vue的错误处理钩子
Vue.config.errorHandler = (err, vm, info) => {
  // 这里可以添加自定义的错误处理逻辑
  // console.error('Vue错误捕获:', err, info)

  captureFrontendException('Vue错误捕获', err, {
    vueInfo: {
      info
    }
  });
  // 保留Vue默认的错误处理行为
  if (typeof console !== 'undefined') {
    console.error(err, info)
  }
}

// 全局捕获未处理的Promise拒绝
window.addEventListener('unhandledrejection', event => {
  // console.error('未处理的Promise拒绝:', event.reason)
  captureFrontendException('未处理的Promise拒绝', event.reason, {
    event: {
      type: event.type,
      reason: serializeError(event.reason)
    }
  });
  event.preventDefault()
})

// 全局捕获JavaScript运行时错误
window.addEventListener('error', event => {
  // console.error('JavaScript运行时错误:', event.error)
  if (event && event.target && event.target !== window && !event.error) {
    return true
  }
  captureFrontendException('JavaScript运行时错误', event.error || event.message);
  return true // 阻止错误冒泡
})
Vue.use(Antd, {
  locale: zhCN,
});
Vue.use(Vant);
Vue.use(BigPowerTable)

Vue.use(VideoPlayer);

import './config/rem'
import './config/common.css'

Vue.prototype.$eventBus = new Vue()

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('BigPowerLoading',BigPowerLoading)
Vue.component('BigPowerInput',BigPowerInput)
import {remoteEmit} from "@/utils/remoteExpose";

//滚动跳滚到.
var VueScrollTo = require('vue-scrollto');
// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

import {dateFormat} from "@/filters/date";
//引入iconfont symbol图标
import "./assets/fonts/iconfont";
// 引入drogzone.js样式
import "../node_modules/dropzone/dist/dropzone.css";

import "@/directives/maskers.js";

Vue.use(ElementUI);

Vue.config.productionTip = false;

import 'animate.css';
import {percentage, toFixed, formatText, chineseNumber, padNumber} from "@/utils/format";
import BigPowerLoading from "@/pages/Result/ThreeYearResult/components/BigPowerLoading";
import BigPowerInput from "@/pages/Result/ThreeYearResult/components/BigPowerInput";
//路由守卫鉴权
const whiteList = [
  "login",
  "register",
  "companyApply",
  "forgetPassword",
  "wxlogin",
  "thirdPartAuth",
  "thirdPartRegister",
  "freeEditionIntroduction",
  "resultFromAdmin",
  "AdminUploadedTables",
  "admin-manual-fill-table",
  "result-head",
  "result-share",
  "result-head-share",
  "result-head-middle-page-share",
  "result",
  "result-head-middle-page",
  "SimpleResultEditor",
  "pdfResult",
  "result-head-always",
  "always-result-head-middle-page",
  "always-result",
  "h5-result-always",
  "shandong",
  "h5-result",
  "h5-result-share",
  "result-oem",
  "test-InvoiceUpload-oem",
  "UploadTable-oem",
  "UploadTable-oem-v2",
  "UploadTable-oem-v3",
  "JinzhiReport-share",
  "view-oem-tables",
  "boss-watch-report"
]; //不需要验证的路由name

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  if (token) {
    next();
  } else {
    if (whiteList.indexOf(to.name) !== -1||1===1) {//有token了 去掉路由白名单
      // 在免登录白名单，直接进入
      next();
    } else {
      //next('/passport/login');
      next({name: "login", query: {redirect: to.path}}); // 否则全部重定向到登录页
    }
  }
});
Vue.filter("timeFormat", function (timeStamp) {
  if (!timeStamp) {
    return "";
  }
  let date = new Date(timeStamp);
  return dateFormat.formatDate(date, "yyyy年MM月d日");
});

Vue.filter("dateFormat", function (timeStamp) {
  if (!timeStamp) {
    return "";
  }
  let date = new Date(timeStamp);
  return dateFormat.formatDate(date, "yyyy年MM月d日");
});

Vue.filter("toFixed", toFixed);
Vue.filter("percentage", percentage);
Vue.filter("formatText", formatText);
Vue.filter("chineseNumber", chineseNumber);
Vue.filter("padNumber", padNumber);

//根据domain设置自定义版本
const debug_customization = ''//调试用

const domain = window.location.hostname.toLowerCase();

if (debug_customization == 'hy.ai-tax.cn' || domain == 'hy.ai-tax.cn') {
  store.commit('setCustomization', {customization: 'hy'})
} else if (debug_customization == 'xr.ai-tax.cn' || domain == 'xr.ai-tax.cn') {
  store.commit('setCustomization', {customization: 'xr'})
} else if (debug_customization == 'nmhz.ai-tax.cn' || domain == 'nmhz.ai-tax.cn') {
  store.commit('setCustomization', {customization: 'nmhz'})
} else {
  store.commit('setCustomization', {customization: ''})
}


(function() {

  if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  }
  }
  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function() {
      WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
    });
  }
})();

window.store = store;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

const tableOfContentWithPageNo=[
  {
    "level": 0,
    "title": "1. 企业发票风险分析演示",
    "pageNo": 1
  },
];

setTimeout(()=>{
  store.commit('PdfResult/setToc', tableOfContentWithPageNo);
},1000)

window.remoteEmit = remoteEmit
